// src/components/music/views/TableView.jsx

import { motion } from 'framer-motion';
import { TableRow } from '../parts/TableRow';

export const TableView = ({
  filteredMusic,
  currentTrack,
  isPlaying,
  playQueue,
  onPlayPause,
  onPurchase,
  processingPayment,
  onAddToPlaylist,
  currentUser,
  isPurchased,
  onDownload
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="overflow-x-auto mb-12"
    >
      <table className="w-full text-white">
        <thead>
          <tr className="border-b border-white/20 text-left">
            <th className="px-4 py-3 font-semibold">Track</th>
            <th className="px-4 py-3 font-semibold">Artist</th>
            <th className="px-4 py-3 font-semibold hidden md:table-cell">Album</th>
            <th className="px-4 py-3 font-semibold hidden md:table-cell">Type</th>
            <th className="px-4 py-3 font-semibold text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredMusic.map((track, index) => (
            <TableRow
              key={track.id}
              track={track}
              index={index}
              isCurrent={currentTrack?.id === track.id}
              isPlaying={isPlaying}
              playQueue={playQueue}
              onPlayPause={onPlayPause}
              onPurchase={onPurchase}
              processingPayment={processingPayment}
              onAddToPlaylist={onAddToPlaylist}
              currentUser={currentUser}
              isPurchased={isPurchased}
              onDownload={onDownload}
            />
          ))}
        </tbody>
      </table>
    </motion.div>
  );
};